import {
  IconMapMarker,
  IconCalendarAlt,
  IconTrophy,
  IconClockFive,
} from '@maia/icons';
import { CustomerDto } from '@maia/shared';
import { cardStyles, SectionWithHeader, SpecList } from '@maia/ui';
import { formatAddress, formatDate, formatDateDifference } from '@maia/utils';
import { twMerge } from 'tailwind-merge';

type BasicCustomerInformationProps = {
  customer: CustomerDto;
};

export function BasicCustomerInformation(props: BasicCustomerInformationProps) {
  const { customer } = props;

  return (
    <SectionWithHeader title="Informatie">
      <div className={twMerge(cardStyles({ variant: 'flat' }), 'p-12')}>
        <SpecList
          items={[
            {
              icon: IconMapMarker,
              title: 'Adres',
              value: formatAddress(customer.address),
            },
            {
              icon: IconCalendarAlt,
              title: 'Geboortedatum',
              value: formatDate(customer.consumer.dateOfBirth),
            },
            {
              icon: IconTrophy,
              title: 'Klant sinds',
              value: formatDateDifference(customer.activeSince),
            },
            {
              icon: IconClockFive,
              title: 'Betaalcyclus',
              value: customer.billingUnit.label,
            },
          ]}
        />
      </div>
    </SectionWithHeader>
  );
}
